import { render, staticRenderFns } from "./MailTemplateModal.vue?vue&type=template&id=43295774&scoped=true"
import script from "./MailTemplateModal.vue?vue&type=script&lang=js"
export * from "./MailTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./MailTemplateModal.vue?vue&type=style&index=0&id=43295774&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43295774",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43295774')) {
      api.createRecord('43295774', component.options)
    } else {
      api.reload('43295774', component.options)
    }
    module.hot.accept("./MailTemplateModal.vue?vue&type=template&id=43295774&scoped=true", function () {
      api.rerender('43295774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mail/MailTemplateModal.vue"
export default component.exports